import { RouteRecordRaw } from "vue-router";

export default {
  path: "/design",
  name: "SceneDesignPage",
  component: () => import("@/views/design/DesignPage.vue"),
  meta: {
    title: "设计模板",
    hideMenu: true,
  },
} as RouteRecordRaw;
